import { Flex } from "@biblioteksentralen/react";
import { Publication } from "@libry-content/types";
import React from "react";
import { useTranslation } from "../../utils/hooks/useTranslation";
import SeMerLenke from "../site/SeMerLenke";
import { getPublicationUrlDeprecated } from "../../utils/getPublicationUrl";
import { useCommonData } from "../layout/CommonDataProvider";

interface Props {
  publication: Publication;
}

const PublicationLink = ({ publication }: Props) => {
  const { t } = useTranslation();
  const { site } = useCommonData();

  const publicationUrl = getPublicationUrlDeprecated({ publication, work: undefined, site });

  return (
    <Flex>
      {/** using nofollow to stop bots from indexing api route (will not be necessary when we use works instead of publications) */}
      {publicationUrl && (
        <SeMerLenke withoutLocale={true} href={publicationUrl} rel="nofollow" variant="primary">
          {t("Reserver")}
        </SeMerLenke>
      )}
    </Flex>
  );
};

export default PublicationLink;
